import React, { useEffect, useState } from "react";
import Logo from "./Logo";

export default function Navbar({ onOpenModal }) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    function onScroll() {
      setScrolled(window.scrollY > 8);
    }
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className={`nav ${scrolled ? "nav--scrolled" : ""}`}>
      <div className="container nav__inner">
        <a href="#top" className="nav__brand" aria-label="SmartUp360 home">
          <Logo />
        </a>

        <nav className="nav__links" aria-label="Primary navigation">
          <a className="nav__link" href="#pillars">
            Pillars
          </a>
          <a className="nav__link" href="#diagnostic">
            Diagnostic
          </a>
          <a className="nav__link" href="#footer">
            Contact
          </a>
        </nav>

        <div className="nav__actions">
          <a className="btn btn--ghost" href="http://waitlist.smartup360.com/">
            Join Waitlist
          </a>
        </div>
      </div>
    </header>
  );
}
